module.exports = __webpack_public_path__ + "static/img/page-bg.969001d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/page-bg.png
// module id = uM8K
// module chunks = 1